import Vue from 'vue'

export const bus = new Vue()

export const _ = undefined
